export enum GenderType {
  M,
  F,
  O,
}

export enum GkboxType {
  NOG,
  ONE,
  EXC,
  PRO,
}

export enum PoliType {
  NOP,
  E,
  EFA2,
  EA,
  S,
  P,
}

export interface PatientFiles {
  fileName: string;
  description?: string;
  fileId: number;
  createdAt?: Date;
  updatedAt?: Date;
  error?: string;
}

export const emptyPatientFile: PatientFiles = {
  fileName: "",
  fileId: -1
};


export interface Patient {
  id?: number;
  cf?: string;
  name: string;
  surname: string;
  gender: GenderType;
  birthDate?: Date;
  birthCity?: string;
  physician?: string;
  email?: string;
  telephone: string;
  telephoneD?: string;
  city?: string;
  province?: string;
  cap?: string;
  street?: string;
  streetNumber?: string;
  height?: number;
  weight?: number;
  footSize?: number;
  strongHand?: number;
  allergies?: string;
  roadc?: string;
  attention?: string;
  gkbox?: GkboxType;
  preexistingConditions?: string;
  additionalNotes?: string;
  relevantIssues?: string;
  avoidTools?: string;
  redFlags?: string;
  protocolExample?: string;
  elicoidali?: boolean; 
  solette?: boolean;   
  privacy?: boolean;
  patientFiles: PatientFiles[];
}



export enum StrongHandType {
  SX,
  SX_DX,
  DX,
}

export const emptyPatient: Patient = {
  name: "",
  surname: "",
  gender: GenderType.M,
  privacy: false,
  solette: false,
  elicoidali: false,
  gkbox: GkboxType.NOG,
  telephone: "",
  patientFiles: []
};
